var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-text',[_c('v-container',[_c('client-add-form')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }